__turbopack_context__.v({
  "active": "NotificationBanner-module__Fj9Aia__active",
  "notificationBanner": "NotificationBanner-module__Fj9Aia__notificationBanner",
});
